{
  "project": {
    "schemaVersion": 1,
    "id": "",
    "name": "",
    "revision": 0,
    "output": {
      "width": 1920,
      "height": 1080,
      "fps": 30
    },
    "board": {
      "width": 5760.0,
      "height": 3240.0,
      "background": {
        "kind": "color",
        "color": "#ffffff",
        "assetId": null
      }
    },
    "defaults": {
      "enter": {
        "mode": "draw",
        "outlineDur": 3.0,
        "fillDur": 1.5,
        "duration": 1.0,
        "direction": "right",
        "handId": null
      },
      "exit": {
        "mode": "none",
        "duration": 0.5,
        "direction": "left"
      },
      "handId": "marker",
      "gapBetweenAudio": 0.6
    },
    "duration": null,
    "assets": [],
    "scenes": [],
    "elements": [],
    "camera": {
      "auto": false,
      "autoPadding": 0.25,
      "autoMaxZoom": 1.8,
      "keyframes": []
    },
    "audio": [],
    "markers": [],
    "ducking": {
      "enabled": true,
      "amountDb": -14.0,
      "attack": 0.25,
      "release": 0.6
    },
    "captions": {
      "enabled": false,
      "size": 44.0,
      "fontAssetId": null,
      "color": "#ffffff",
      "background": "#000000b3"
    },
    "subtitles": [],
    "vocabulary": []
  },
  "asset": {
    "id": "",
    "kind": "image",
    "name": "",
    "file": "",
    "width": null,
    "height": null,
    "duration": null,
    "analysis": null,
    "anchor": null,
    "scale": null
  },
  "scene": {
    "id": "",
    "name": "",
    "number": null,
    "start": 0.0,
    "startMode": "clear",
    "transition": {
      "type": "cut",
      "duration": 0.0,
      "direction": "right"
    },
    "frame": null,
    "caption": null
  },
  "element": {
    "id": "",
    "sceneId": "",
    "type": "image",
    "name": "",
    "z": 0.0,
    "locked": false,
    "hidden": false,
    "opacity": 1.0,
    "transform": {
      "x": 0.0,
      "y": 0.0,
      "scale": 1.0,
      "rotation": 0.0,
      "flipX": false,
      "flipY": false
    },
    "start": 0.0,
    "enter": {
      "mode": "draw",
      "outlineDur": 3.0,
      "fillDur": 1.5,
      "duration": 1.0,
      "direction": "right",
      "handId": null
    },
    "hold": null,
    "exit": {
      "mode": "none",
      "duration": 0.5,
      "direction": "left"
    },
    "image": null,
    "text": null,
    "shape": null
  },
  "imageProps": {
    "assetId": "",
    "brushScale": 1.0,
    "groupOrder": null
  },
  "textProps": {
    "content": "",
    "fontAssetId": "",
    "size": 120.0,
    "color": "#223042",
    "align": "left",
    "lineHeight": 1.15,
    "writeMode": "write",
    "underline": null
  },
  "shapeProps": {
    "kind": "rect",
    "points": [],
    "w": 200.0,
    "h": 120.0,
    "stroke": "#222222",
    "strokeWidth": 8.0,
    "fill": null
  },
  "underline": {
    "color": "#345ca0",
    "width": 9.0,
    "offset": 18.0,
    "tilt": -8.0
  },
  "audioClip": {
    "id": "",
    "assetId": "",
    "role": "voice",
    "track": 0,
    "start": 0.0,
    "trimIn": 0.0,
    "trimOut": null,
    "volume": 1.0,
    "fadeIn": 0.0,
    "fadeOut": 0.0
  },
  "cameraKey": {
    "id": "",
    "t": 0.0,
    "x": 0.0,
    "y": 0.0,
    "zoom": 1.0,
    "rotation": 0.0,
    "easing": "easeInOut",
    "source": "manual"
  },
  "marker": {
    "id": "",
    "t": 0.0,
    "label": ""
  }
}
